import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AdministeredServiceModel from "../../models/administered-service";
import qs from "query-string";

export default class AdministeredServiceRepository extends BaseRepository {
  static modelClass = AdministeredServiceModel;
  modelName = "administered-service";

  async setUrlPath(providerId) {
    super.modelClass.setUrlPath(providerId);
  }

  async query(params) {
    let otherThanProviderIdParams = {};
    for (let key in params) {
      if (key !== "providerId") {
        otherThanProviderIdParams[key] = params[key];
      }
    }
    return await super.query({
      urlPath: "services/?" + qs.stringify(otherThanProviderIdParams),
    });
  }

  async createBulk(data) {
    return await super.createBulk(data, {
      urlPath: "administered/bulk_create",
    });
  }

  async updateBulk(data) {
    return await super.createBulk(data, {
      urlPath: "administered/bulk_update",
    });
  }

  async deleteBulk(data) {
    return await super.createBulk(data, {
      urlPath: "administered/bulk_delete",
    });
  }
}
